// Upcoming subscription billings by date for the next 60 days, starting today.
// Shared by the dashboard's "Next 7 days" strip and the Subscriptions calendar.

export interface UpcomingBillingDay {
  date: string; // YYYY-MM-DD
  count: number;
}

// Subscriptions due per day, from today onwards. Mostly quiet days, with a
// release day three days out and a couple of later spikes.
const DAILY_COUNTS = [2, 1, 0, 14, 3, 0, 1, 2, 0, 1, 3, 2, 9, 1, 0, 2, 1, 0, 3, 1, 2, 11, 2, 0, 1, 3, 0, 2, 1, 1, 0, 2, 3, 1, 0, 1, 2, 0, 3, 1, 8, 2, 0, 1, 2, 1, 0, 3, 2, 0, 1, 2, 1, 0, 2, 3, 1, 0, 1, 2];

export function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Parses a YYYY-MM-DD string as a local date (not UTC).
export function fromIsoDate(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day);
}

// "1 Oct 2026"
export function formatBillingDayLabel(isoDate: string): string {
  return fromIsoDate(isoDate).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

function buildUpcomingBillings(): UpcomingBillingDay[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return DAILY_COUNTS.map((count, offset) => {
    const date = new Date(today);
    date.setDate(today.getDate() + offset);
    return {
      date: toIsoDate(date),
      count
    };
  });
}

export const upcomingBillings: UpcomingBillingDay[] = buildUpcomingBillings();

const countsByDate = new Map(upcomingBillings.map(day => [day.date, day.count]));

// Number of subscriptions due on a given date (0 outside the 60-day window).
export function getUpcomingBillingCount(date: Date | string): number {
  const key = typeof date === 'string' ? date : toIsoDate(date);
  return countsByDate.get(key) ?? 0;
}
